import { useFormContext } from '@calendly/form'
import { useCallback } from 'react'

import { useEventTypeContext } from 'features/event_type_provider'

import { useUserPoolSidePanelActions } from './user_pool_side_panel/context'
import { useFormHandleSubmit } from '../../../../../hooks'

export const useHandleApplyAndClose = ({ eventType, isLocked }) => {
  const { closeUserPoolSidePanel } = useUserPoolSidePanelActions()
  const { isSubmitting } = useFormContext()
  const { isCreation } = useEventTypeContext()

  const formHandleSubmit = useFormHandleSubmit({ validateOnly: isCreation })

  const isNewEventType = !eventType?.id
  const shouldAutoSave = !isNewEventType && !isLocked && !isSubmitting

  return useCallback(() => {
    if (shouldAutoSave) { formHandleSubmit() }

    closeUserPoolSidePanel()
  }, [shouldAutoSave, closeUserPoolSidePanel, formHandleSubmit])
}
